import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './inputField.css';
import {Checkbox, Button} from 'antd';
import { utils } from '../../../config';
import Translation from '../../../Translation';

/**
 * Class for input field global component.
 *
 * @class InputField
 * @extends {React.Component}
 */
const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
export default class InputField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            checked: !this.props.disabled,
            value: this.props.value || 0,
            toDBValue: null,
            inputType: 'text',
            userPreferenceState: null,
            information: false
        };
        this.isIE11 = document.body.classList.contains('ie11');
        this.handleChange = this.handleChange.bind(this);
        this.handleOnChecked = this.handleOnChecked.bind(this);
        this.onChange = this.onChange.bind(this);
        // this.checkValidity = this.checkValidity.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.input = React.createRef();
    }

    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    componentDidMount() {
        const pref = this.capitalize(this.props.type);
        this.setState({
            checked: !this.props.disabled
        })
        switch (pref) {
            case 'Text':
                this.setState({inputType: 'text'});
                break;
            case 'Password':
                this.setState({inputType: 'password'});
                break;
            case 'Number':
            default : 
                this.setState({inputType:'number'});
        }
        // let userPreferenceState = null;
        
        // if(Utils.DefaultPreferences[pref]){
        //     var a = Utils.DefaultPreferences[pref].units.filter(e => {
        //         if(e.name == Utils.UserPreferences[pref])
        //             return e;
        //     });  
            
        //     userPreferenceState = a[0] || Utils.DefaultPreferences[pref].default;}
        // this.setState({userPreferenceState}, ()=>{
        //     if(this.state.userPreferenceState)
        //         this.setState({suffix: this.state.userPreferenceState.name});
        // });

    }
    handleChange(e) {
        const hasCommaNotChrome = !isChrome && !utils.isUSRegion();
        if (e && e.target) {
            if (hasCommaNotChrome && e.target.value.indexOf(',') >= 0) {
                e.target.value = e.target.value.replace(',', '.');
            }
            this.validateInput(e.target.value);
        }
        if(this.props.onBlur) {
            // this.isIE11 is taking as false on blur
            if (hasCommaNotChrome && e.target.value.indexOf(',') >= 0) {
                e.target.value = e.target.value.replace(',', '.');
            }
            this.props.onBlur(e, this.state);
        }
    }

    /**
     * validateInput function is for showing appropriate error messages and for validating the input fields
     * @param {string} a here a is the value of the field user is typing in 
     * @memberof InputField
     */
    validateInput(a) {
        const num = parseFloat(a);

        if (this.props.readOnly || this.props.disabled) {
            return;
        }

        switch (this.state.inputType) {
            case 'number':
                if (a === '') {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_please_fill_field" defaultText="Please fill this field"/>,
                        invalid: true,
                        information: false
                    });
                }
                else if (num < 0) {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_cannot_be_0" defaultText="Value cannot be < zero"/>,
                        invalid: true,
                        information: false
                    });
                }
                else if (this.props.allowedZero){
                    this.setState({
                        errorMessage: '',
                        invalid: false,
                        information: false
                    });
                }
                else if (num === 0) {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_value_cannot_be_zero" defaultText="Value cannot be zero"/>,
                        invalid: true,
                        information: false
                    });
                }
                else if (num > parseFloat(this.props.maxValue)) {
                    this.setState({
                        errorMessage: this.props.errorMax,
                        information: false,
                        invalid: true
                    });
                    return ;
                }
                else if (num < parseFloat(this.props.min) || num > parseFloat(this.props.max)) {
                    this.setState({
                        errorMessage: this.props.errorMinMax !== undefined ? this.props.errorMinMax : this.props.informationMessage,
                        information: false,
                        invalid: true
                    });
                }
                
                else if (this.props.precision && ( +(+num || 0).toFixed(this.props.precision) !== +num)) {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_precision_error" defaultText="Precision Error"/>,
                        invalid: true
                    });
                }
                else {
                    this.setState({
                        errorMessage: '',
                        invalid: false
                    });
                }

                break;

            default:
            case 'text':
                var pattern = new RegExp(this.props.pattern);
                if (a === '') {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_please_fill_field" defaultText="Please fill this field"/>,
                        invalid: true
                    });
                }
                else if (!a.match(pattern)) {
                    this.setState({
                        errorMessage: <Translation labelName="err_msg_pattern_does_not_match" defaultText="Pattern does Not match"/>,
                        invalid: true
                    });
                }
                else {
                    this.setState({
                        errorMessage: '',
                        invalid: false
                    });
                }
                break;  
        }
    }
    onChange(e) {
        const hasCommaNotChrome = !isChrome && !utils.isUSRegion();
        if (hasCommaNotChrome && e.target.value.indexOf(',') >= 0) {
            e.target.value = e.target.value.split(',').join('.');
        }
        if(this.props.onChange) {
            this.props.onChange(e, this.state );
        }

    }
    handleOnChecked(e) {
        if (this.props.onChecked) {
            this.props.onChecked(e.checked);
        }
    }

    render() {
        const hasCommaNotChrome = !isChrome && !utils.isUSRegion();
        return (
                <div disabled={this.props.compDisabled ? "disabled" : ""} className={this.props.className + ' inputfield ' + (this.state.invalid  ? 'has-error' : '')+ (this.props.showCheckBox ? 'has-check':'')}>
                     { this.props.label ? <label htmlFor={this.props.name}
                        className='inputfield-label'> {this.props.label}  <span>{this.props.units ? this.props.units : ''}</span></label>
                     : ''} 
                        {this.state.inputType === 'number' && <Fragment>
                            <span className={this.state.errorMessage? 'has-error': ''}>
                            {this.props.showCheckBox &&
                                <Checkbox
                                    onChange={this.handleOnChecked}
                                    checked={!this.props.disabled}
                            />}
                            <input type={'number'} className={this.props.className + '-input inputfield-input ant-input ' + (this.props.disabled ? 'ant-input-disabled' : '')}
                                id={this.props.name}
                                name={this.props.name}
                                disabled={this.props.disabled}
                                readOnly={this.props.readOnly}
                                min={this.props.min}
                                max={this.props.max}
                                precision={this.props.precision}
                                onBlur={this.handleChange}
                                ref={this.input}
                                data-invalid={this.state.invalid && !this.props.disabled}
                                value={ hasCommaNotChrome && typeof this.props.value === 'string' && this.props.value.indexOf('.') >= 0 ? this.props.value.split('.').join(',') : this.props.value }
                                onChange={this.onChange}
                                autoComplete="off"
                            />
                            {this.state.errorMessage && !this.props.disabled && !this.props.readOnly &&
                                <span className="ant-form-explain">{this.state.errorMessage || this.state.informationMsg}</span>
                            }
                            {this.props.buttonIcon && 
                                <Button 
                                    type="Primary"
                                    className="btn-primary"
                                    icon={this.props.buttonIcon} 
                                    onClick={this.props.onButtonClick}
                                />
                            }
                            </span>
                        </Fragment>
                    }
                    {this.state.inputType === 'text' &&
                        <input type={'text'} 
                            className={this.props.className + '-input inputfield-input  ant-input ' + (this.props.disabled ? 'ant-input-disabled' : '')}
                            id={this.props.name}
                            name={this.props.name}
                            disabled={this.props.disabled}
                            pattern={this.props.pattern}
                            maxLength={this.props.maxLength}
                            onBlur={this.handleChange}
                            ref={this.input}
                            value={this.props.value}
                            data-invalid={this.state.invalid}
                            onChange={this.onChange}
                            autoComplete="off"
                        />
                    }

                    {this.state.inputType === 'password' &&
                        <input type={'password'} 
                            className={this.props.className + '-input inputfield-input  ant-input ' + (this.props.disabled ? 'ant-input-disabled' : '')}
                            id={this.props.name}
                            name={this.props.name}
                            disabled={this.props.disabled}
                            pattern={this.props.pattern}
                            maxLength={this.props.maxLength}
                            onBlur={this.handleChange}
                            ref={this.input}
                            value={this.props.value}
                            data-invalid={this.state.invalid}
                            onChange={this.onChange}
                            autoComplete="off"
                        />
                    }
                    
                    {this.state.suffix &&                    
                        <span className="inputfield-suffix">{this.state.suffix}</span>
                    }
                    {!this.state.information === '' &&
                        <span className="information">{this.state.informationMsg}</span>
                    }
                </div>
        );
    }
}

InputField.propTypes = {
    type: PropTypes.PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ]),
    buttonIcon: PropTypes.string,
    onChecked: PropTypes.func,
    showCheckBox: PropTypes.bool,
    readOnly: PropTypes.bool,
    label: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    compDisabled: PropTypes.bool,
    min: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    max: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    precision: PropTypes.number,
    pattern: PropTypes.string,
    maxLength: PropTypes.number,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onButtonClick: PropTypes.func,
    informationMessage: PropTypes.any,
    allowedZero: PropTypes.bool,
    errorMax: PropTypes.any,
    maxValue:  PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    units: PropTypes.any,
    errorMinMax:PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/global/InputField/index.js